import clsx from 'clsx'
import {useMemo} from 'react'
import {useQueryRequest} from '../../../../../../../common/modules/apps/user-management/users-list/core/QueryRequestProvider'

const ActionCustomHeader = (props: any) => {
  const id = props.tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  //   const sortColumn = () => {
  //     // avoid sorting for these columns
  //     if (id === 'actions' || id === 'selection') {
  //       return
  //     }

  //     if (!isSelectedForSorting) {
  //       // enable sort asc
  //       updateState({sort: id, order: 'asc', ...initialQueryState})
  //       return
  //     }

  //     if (isSelectedForSorting && order !== undefined) {
  //       if (order === 'asc') {
  //         // enable sort desc
  //         updateState({sort: id, order: 'desc', ...initialQueryState})
  //         return
  //       }

  //       // disable sort
  //       updateState({sort: undefined, order: undefined, ...initialQueryState})
  //     }
  //   }

  return (
    <th
      {...props.tableProps.column.getHeaderProps()}
      className={clsx(
        props.className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`
      )}
      style={{cursor: 'pointer'}}
      //   onClick={sortColumn}
    >
      {props.title}
    </th>
  )
}

export {ActionCustomHeader}
